import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { useGetSubscriptionLevelQuery } from "../../api/subscriptionApi";
import {
  hasSubscriptionAccess,
  SubscriptionLevel,
} from "../../constants/subscriptionLevels";

interface SubscriptionLevelGateProps {
  requiredLevel: SubscriptionLevel;
}

/**
 * Renders child routes only if the current user's subscription level meets requiredLevel.
 * Otherwise redirects to subscription or subscription-required page.
 */
const SubscriptionLevelGate: React.FC<SubscriptionLevelGateProps> = ({
  requiredLevel,
}) => {
  const user = useAppSelector((state) => state.auth.user);
  const { data, isLoading } = useGetSubscriptionLevelQuery(undefined, {
    skip: !user,
    refetchOnMountOrArgChange: true,
  });
  const level = data?.level ?? null;

  if (isLoading) {
    return null; // or a small spinner
  }

  const hasAccess = hasSubscriptionAccess(level, requiredLevel);
  if (!hasAccess) {
    const isAdmin = user?.role === "Admin";
    return (
      <Navigate
        to={isAdmin ? "/subscription" : "/subscription-required"}
        replace
      />
    );
  }

  return <Outlet />;
};

export default SubscriptionLevelGate;
